import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const LogoIcon = (props: IconProps) => (
  <Icon w="74px" h="85px" viewBox="0 0 74 85" {...props}>
    <path
      d="M61.4346 24.2389H12.5981C5.8559 24.2389 0.388916 29.6657 0.388916 36.3583C0.388916 43.0509 5.8559 48.4778 12.5981 48.4778H61.4346C68.1768 48.4778 73.6438 53.9046 73.6438 60.5972V36.3583C73.6438 29.6657 68.1768 24.2389 61.4346 24.2389Z"
      fill="url(#paint0_linear_4068_91)"
    />
    <path
      d="M61.4343 48.4778H37.016C30.2739 48.4778 24.8069 53.9046 24.8069 60.5972V72.7166V84.8361C24.8069 78.1435 30.2739 72.7166 37.016 72.7166H61.4343C68.1765 72.7166 73.6434 67.2898 73.6434 60.5972C73.6434 53.9046 68.1765 48.4778 61.4343 48.4778Z"
      fill="url(#paint1_linear_4068_91)"
    />
    <path
      d="M12.5981 0C5.8559 0 0.388916 5.42681 0.388916 12.1194V36.3583C0.388916 29.6657 5.8559 24.2389 12.5981 24.2389H37.0163C43.7585 24.2389 49.2255 18.812 49.2255 12.1194V0H12.5981Z"
      fill="url(#paint2_linear_4068_91)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4068_91"
        x1="0.388916"
        y1="42.418"
        x2="73.6438"
        y2="42.418"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F16431" />
        <stop offset="0.36" stopColor="#F68F1D" />
        <stop offset="0.79" stopColor="#FCBD08" />
        <stop offset="1" stopColor="#FFCF00" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4068_91"
        x1="24.8069"
        y1="66.6569"
        x2="73.6434"
        y2="66.6569"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F16431" />
        <stop offset="0.34" stopColor="#EE6130" />
        <stop offset="0.56" stopColor="#E85830" />
        <stop offset="0.75" stopColor="#DC492F" />
        <stop offset="0.91" stopColor="#CC352D" />
        <stop offset="1" stopColor="#C1272D" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_4068_91"
        x1="0.388916"
        y1="18.1791"
        x2="49.2255"
        y2="18.1791"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF9500" />
        <stop offset="0.09" stopColor="#FFA900" />
        <stop offset="0.19" stopColor="#FFBA00" />
        <stop offset="0.32" stopColor="#FFC600" />
        <stop offset="0.5" stopColor="#FFCD00" />
        <stop offset="1" stopColor="#FFCF00" />
      </linearGradient>
    </defs>
  </Icon>
);

export default memo(LogoIcon);
